import React from 'react';
import { SECTIONS } from '../../config/sections';
import { useLanguage } from '../../i18n/LanguageContext';
import '../static/Footer.css';

const Footer = () => {
    const { t } = useLanguage();

    return (
        <footer className='footer-section' id={SECTIONS.FOOTER}>
            <div className='footer-content'>
                {/* Logo Column */}
                <div className='footer-column logo-column'>
                    <img
                        src="/BCCC_logo.png"
                        alt="Brooklyn Community Christian Church Logo"
                        className="footer-logo"
                    />
                    <p className="footer-tagline">
                        {t('footer.tagline')}
                    </p>
                </div>

                {/* Contact Info Column */}
                <div className='footer-column contact-column'>
                    <h4 className="footer-heading">{t('footer.contactHeading')}</h4>
                    <div className="contact-item">
                        <i className="fas fa-map-marker-alt"></i>
                        <div>
                            <p className="contact-text">{t('footer.address1')}</p>
                            <p className="contact-text">{t('footer.address2')}</p>
                        </div>
                    </div>
                    <div className="contact-item">
                        <i className="fas fa-phone"></i>
                        <a href="tel:7189342346" className="contact-link">
                            718 934 2346
                        </a>
                    </div>
                    <div className="contact-item">
                        <i className="fas fa-envelope"></i>
                        <a href="mailto:bccc.connect@gmail.com" className="contact-link">
                            bccc.connect@gmail.com
                        </a>
                    </div>
                </div>

                {/* Social Media Column */}
                <div className='footer-column socials-column'>
                    <h4 className="footer-heading">{t('footer.followHeading')}</h4>
                    <div className="social-links">
                        <a
                            href="https://www.instagram.com/bccc_ig"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-link"
                            aria-label="Visit our Instagram page"
                        >
                            <i className="fab fa-instagram"></i>
                            <span>Instagram</span>
                        </a>
                        <a
                            href="https://www.youtube.com/@bcccvideos7178"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-link"
                            aria-label="Visit our YouTube channel"
                        >
                            <i className="fab fa-youtube"></i>
                            <span>YouTube</span>
                        </a>
                    </div>
                </div>
            </div>

            {/* Copyright Bar */}
            <div className="footer-bottom">
                <p className="copyright">
                    &copy; {new Date().getFullYear()} {t('footer.copyright')}
                </p>
            </div>
        </footer>
    );
}

export default Footer;
